import Vue from 'vue'
import { Input, Button, Select, Radio, CheckboxGroup, Checkbox, Option, Notification } from 'element-ui'

Vue.use(Input).use(Button).use(Select).use(Radio).use(CheckboxGroup).use(Checkbox).use(Option)
Vue.prototype.$notify = Notification
